import React, { useRef, useState } from "react";
import { Button } from "@/components/ui/button";

// Ajuste manual de las 4 esquinas sobre una imagen. pts en coordenadas de la imagen original.
export default function AjusteEsquinas({ imagen, inicial, onAplicar, onCancelar }) {
  const W = imagen.width, H = imagen.height;
  const [pts, setPts] = useState(inicial || [{ x: W * 0.1, y: H * 0.1 }, { x: W * 0.9, y: H * 0.1 }, { x: W * 0.9, y: H * 0.9 }, { x: W * 0.1, y: H * 0.9 }]);
  const box = useRef(null);
  const drag = useRef(null);
  const mover = (e) => {
    if (drag.current == null) return;
    const r = box.current.getBoundingClientRect();
    const x = Math.min(W, Math.max(0, ((e.clientX - r.left) / r.width) * W));
    const y = Math.min(H, Math.max(0, ((e.clientY - r.top) / r.height) * H));
    setPts((p) => p.map((q, i) => (i === drag.current ? { x, y } : q)));
  };
  const poly = pts.map((p) => `${(p.x / W) * 100},${(p.y / H) * 100}`).join(" ");
  return (
    <div className="flex flex-col h-full" data-testid="ajuste-esquinas">
      <p className="text-white text-center text-sm py-2">Arrastra las 4 esquinas a las puntas de la remisión</p>
      <div className="flex-1 flex items-center justify-center min-h-0 p-6">
        <div ref={box} className="relative touch-none select-none max-h-full" style={{ aspectRatio: `${W}/${H}`, maxWidth: "100%", height: "100%" }}
          onPointerMove={mover} onPointerUp={() => { drag.current = null; }} onPointerLeave={() => { drag.current = null; }}>
          <img src={imagen.toDataURL("image/jpeg", 0.8)} alt="Captura" className="absolute inset-0 w-full h-full" draggable={false} />
          <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 w-full h-full pointer-events-none">
            <polygon points={poly} fill="rgba(250,204,21,0.15)" stroke="#facc15" strokeWidth="0.6" />
          </svg>
          {pts.map((p, i) => (
            <div key={i} onPointerDown={(e) => { e.currentTarget.setPointerCapture?.(e.pointerId); drag.current = i; }}
              onPointerMove={mover} onPointerUp={() => { drag.current = null; }}
              className="absolute h-9 w-9 -ml-[18px] -mt-[18px] rounded-full border-4 border-yellow-400 bg-yellow-400/30"
              style={{ left: `${(p.x / W) * 100}%`, top: `${(p.y / H) * 100}%` }} data-testid={`esquina-${i}`} />
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 p-3">
        <Button variant="outline" className="h-12" onClick={onCancelar} data-testid="ajuste-cancelar">Repetir</Button>
        <Button className="h-12 bg-yellow-500 hover:bg-yellow-600 text-black" onClick={() => onAplicar(pts)} data-testid="ajuste-aplicar">Aplicar</Button>
      </div>
    </div>
  );
}
